import * as e from "react";
const r = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M29.336 40h5.333v5.333h-5.333zm0-21.333h5.333v16h-5.333zm2.64-13.334C17.256 5.333 5.336 17.28 5.336 32s11.92 26.667 26.64 26.667c14.747 0 26.693-11.947 26.693-26.667S46.723 5.333 31.976 5.333m.027 48c-11.787 0-21.334-9.546-21.334-21.333s9.547-21.333 21.334-21.333S53.336 20.213 53.336 32s-9.547 21.333-21.333 21.333" }));
export {
  r as default
};
